import {
    sendPostRequest, sendPatchRequest, sendDeleteRequest, sendGetRequest
} from "@/helper/requests";
import choices from "@/urls/choices";

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
    loadOrderTypeChoices: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = choices.CHOICES.FIELDS.ORDER_TYPE()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadOrderStatusChoices: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = choices.CHOICES.FIELDS.ORDER_STATUS()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadPurposeChoices: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = choices.CHOICES.FIELDS.PURPOSE()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadColorChoices: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = choices.CHOICES.FIELDS.COLOR()
        sendGetRequest(
            url, finalizer, catcher
        )
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}